import {
  RDX_DEMO_DATA_FETCH,
  RDX_DEMO_DATA_SAVE,
  RDX_DEMO_DATA_FETCH_DONE,
  RDX_DEMO_DATA_SAVE_DONE,
  RDX_DEMO_DATA_FETCH_ERR,
  RDX_DEMO_DATA_SAVE_ERR,
} from './demoAction';

const initialState = {
  demoName: 'N/A',
  demoId: 'N/A',
};

const demo = (state = initialState, action) => {
  let newState = {...state};
  switch (action.type) {
    case RDX_DEMO_DATA_FETCH:
      return state;
    case RDX_DEMO_DATA_FETCH_DONE:
      newState = Object.assign({}, action.data);
      return newState;
    case RDX_DEMO_DATA_FETCH_ERR:
      return state;
    case RDX_DEMO_DATA_SAVE:
      return state;
    case RDX_DEMO_DATA_SAVE_DONE:
      return state;
    case RDX_DEMO_DATA_SAVE_ERR:
      return state;
    default:
      return state;
  }
};

export default demo;
